import React, { useState } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "./PDFViewer.css";

const PDFViewer = ({ title, file, show }) => {
  const [showPDF, setShowPDF] = useState(show);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  return (
    <div className="pdf-container">
      {/* Title */}
      <h2 className="pdf-title">{title}</h2>

      {/* Toggle Button */}
      <button className="toggle-btn" onClick={() => setShowPDF(!showPDF)}>
        {showPDF ? "Hide PDF" : "Show PDF"}
      </button>

      {/* PDF Viewer with Scroll Support */}
      <div className={`pdf-wrapper ${showPDF ? "show" : "hide"}`}>
        {showPDF && (
          <Worker workerUrl="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js">
            <div className="pdf-viewer">
              <Viewer fileUrl={file} plugins={[defaultLayoutPluginInstance]} />
            </div>
          </Worker>
        )}
      </div>
    </div>
  );
};

export default PDFViewer;
